<template>
  <v-card>
    <v-card-title>
      <span class="me-3">({{ prospects.length }}) Prospects</span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="prospects"
      item-key="id"
      class="table-rounded"
      :items-per-page="10"
      disable-sort
      :search="search"
    >
      <template #[`item.prospect_name`]="{ item }">
        <span class="font-weight-semibold text--primary text-truncate d-block">
          {{ item.prospect_name }}
        </span>
      </template>

      <!-- Intérêts : puce tronquée avec tooltip complet -->
      <template #[`item.preferences`]="{ item }">
        <v-tooltip v-if="item.preferences" bottom max-width="260">
          <template #activator="{ on }">
            <v-chip x-small color="teal lighten-4" v-on="on"
                    class="text-truncate" style="max-width:160px">
              <v-icon x-small left>mdi-star-outline</v-icon>
              {{ item.preferences }}
            </v-chip>
          </template>
          <span>{{ item.preferences }}</span>
        </v-tooltip>
        <span v-else class="grey--text text--lighten-1">—</span>
      </template>

      <template #[`item.get_date_str`]="{ item }">
        {{ item.get_date_str }}
      </template>

      <template #[`item.actions`]="{ item }">
        <v-btn icon small color="green" @click="openWhatsApp(item)" title="WhatsApp">
          <v-icon small>mdi-whatsapp</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mdiSquareEditOutline, mdiDotsVertical } from '@mdi/js'
import axios from 'axios'

export default {
  data() {
    return {
      headers: [
        { text: 'Name',        value: 'prospect_name' },
        { text: 'Profession',  value: 'profession' },
        { text: 'Phone',       value: 'phone_number' },
        { text: 'Email',       value: 'email' },
        { text: 'Location',    value: 'location' },
        { text: 'Interests', value: 'preferences' },   // ← renommé         // ← nouveau
        { text: 'Date/Time',   value: 'get_date_str' },
        { text: 'Actions',     value: 'actions', sortable: false, align: 'center' },
      ],
      prospects: [],
      search: '',
      icons: { mdiSquareEditOutline, mdiDotsVertical },
    }
  },

  mounted() {
    this.getProspectsDetails()
    document.title = 'TopUp | List of Prospects'
  },

  methods: {
    getProspectsDetails() {
      const list_id = this.$route.params.id
      axios
        .get(`/api/v1/topup/get/prospects_list/${list_id}/details/`)
        .then(r => { this.prospects = r.data })
        .catch(err => {
          const msg = err.response
            ? `${err.response.status} ${err.response.statusText}`
            : 'Vérifiez votre connexion.'
          this.$store.commit('setSnackBarMessage', msg)
          this.$store.commit('setSnackBarColor', 'red darken-4')
          this.$store.commit('activateSnackBar', true)
        })
    },

    openWhatsApp(prospect) {
      const phone = this.formatPhone(prospect.phone_number)
      if (!phone) { this.showToast('No valid phone number', 'warning'); return }
      const msg = `Hello ${prospect.prospect_name}, I'm your PettyCash agent. How can I help you?`
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, '_blank')
    },

    formatPhone(raw) {
      if (!raw) return ''
      let d = raw.replace(/\D/g, '')
      if (d.startsWith('0')) d = d.substring(1)
      if (d.length === 9) d = '237' + d
      return d ? `+${d}` : ''
    },

    showToast(msg, type) {
      this.$store.commit('setSnackBarMessage', msg)
      this.$store.commit('setSnackBarColor', type === 'warning' ? 'orange darken-2' : 'red darken-4')
      this.$store.commit('activateSnackBar', true)
    },
  },
}
</script>
